import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  gameOverTime: {
    fontSize: '22px',
    textAlign: 'center',
  },
  clockImage: {
    paddingRight: '10px',
    fontSize: '40px',
  },
}))

export default useStyles
